import { useState } from "react";
import { Link } from "react-router-dom";

import QuickEventSourceCapture from "@/components/QuickEventSourceCapture";
import RegionalSourcePackPanel from "@/components/RegionalSourcePackPanel";
import EventSourceWatcherStatusStrip from "@/components/EventSourceWatcherStatusStrip";
import FacebookManualSignalPanel from "@/components/FacebookManualSignalPanel";
import FacebookReviewQueuePanel from "@/components/FacebookReviewQueuePanel";
import AutopilotReviewPanel from "@/components/AutopilotReviewPanel";
import ModEventSources from "@/pages/ModEventSources";

export default function ModEventSourcesEnhanced() {
  const [version, setVersion] = useState(0);
  const refreshSources = () => setVersion((value) => value + 1);

  return (
    <>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 pt-4">
        <Link to="/mod/flode" className="inline-flex text-xs font-semibold text-pine border border-pine px-3 py-1.5 rounded-sm no-underline mb-3">Öppna Flödet</Link>
      </div>
      <EventSourceWatcherStatusStrip />
      <AutopilotReviewPanel />
      <QuickEventSourceCapture onSaved={refreshSources} />
      <RegionalSourcePackPanel onImported={refreshSources} />
      <FacebookManualSignalPanel />
      <FacebookReviewQueuePanel />
      <ModEventSources key={version} />
    </>
  );
}
